module.exports = __webpack_public_path__ + "static/media/ManageMultiUser2.c56bd638.png";